const UPDATES = [
	{	
		id: 0,
		author: 'Amy',
		date: 'Nov 21, 2017',
		responses: [
			{
				author: 'Michelle',
				date: '9 minutes ago'
			},
			{
				author: 'Hannah',
				date: '5 minutes ago'
			}
		]
	},
	{
		id: 1,
		author: 'Hannah',
		date: 'Nov 20, 2017',
		responses: [
			{
				author: 'Hannah',
				date: '10:23am Today'
			},
			{
				author: 'Michelle',
				date: '1 hour ago'
			},
			{
				author: 'Jeffery',
				date: '18 minutes ago'
			}
		]
	},
	{
		id: 2,
		author: 'Michelle',
		date: 'Nov 18, 2017',
		responses: [
			{
				author: 'Michelle',
				date: '3 hour(s) ago'
				
			},
			{
				author: 'Hannah',
				date: '2 hour(s) ago'
			},
			{
				author: 'Jeffery',
				date: '9 minutes ago'
			}						
		]
	},
	{
		id: 3,
		author: 'Jeremy',
		date: 'Nov 16, 2017',
		responses: [
			{
				author: 'Jeremy',
				date: '2:34 pm Today'
			}
		]
	},
	{
		id: 4,
		author: 'Jeffery',
		date: 'Nov 15, 2017',
		responses: [
			{
				author: 'Jeffery',
				date: '3 minutes ago'
			},
			{
				author: 'Hannah',
				date: '2 hours ago'
			}			
		]
	},
	{
		id: 5,
		author: 'Hannah',
		date: 'Nov 11, 2017',
		responses: [
			{
				author: 'Hannah',
				date: 'Nov 11, 2017, 4:55pm'
			}
		]
	}

]


export default UPDATES


// WEBPACK FOOTER //
// ./src/data/dummy.js